import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
  Grid as SemanticGrid,
  Icon as SemanticIcon,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const ContainerQuestion = styled.div`
  margin-bottom: 20px;

  :last-child {
    margin-bottom: 0px;
  }
`;

const FieldValue = styled(TextLayoutComponent)`
  word-wrap: break-word;
`;

const FieldName = styled(TextLayoutComponent.Bold)``;

const Grid = styled(SemanticGrid)`
 &&& {
    margin-bottom: 0px;
    margin-top: 0px;

    .row {
      padding: 5px 0px;
    }
  }
`;

const Column = styled(SemanticGrid.Column)``;

const Row = styled(SemanticGrid.Row)`
  &&& {
    word-wrap: break-word;
  }
`;

export const ImageVideoQuestionLabel = ({ href }) => (
  <span>
    Please navigate to
    {' '}
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={href}
    >
      this website
      {' '}
      <sup>
        <SemanticIcon name="external alternate" size="small" />
      </sup>
    </a>
  </span>
);

const AudioContainerStyle = `
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AudioQuestionLabel = ({ href }) => (
  <span>
    Please navigate to
    {' '}
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={href}
      onClick={(e) => {
        e.preventDefault();
        const newTab = window.open('', '_blank');
        newTab.document.write(`
          <html>
            <head>
              <title>Playbook Question Audio</title>
            </head>
            <body style='${AudioContainerStyle}'>
              <audio controls>
                <source src=${href} type='audio/mpeg' />
                Your browser does not support the audio element.
              </audio>
            </body>
          </html>
          `);
        newTab.focus();
      }}
    >
      this website
      {' '}
      <sup>
        <SemanticIcon name="external alternate" size="small" />
      </sup>
    </a>
  </span>
);

ImageVideoQuestionLabel.propTypes = {
  href: PropTypes.string.isRequired,
};

AudioQuestionLabel.propTypes = {
  href: PropTypes.string.isRequired,
};

export {
  ContainerQuestion,
  FieldValue,
  FieldName,
  Grid,
  Column,
  Row,
};
